import { render, staticRenderFns } from "./addEvidence.vue?vue&type=template&id=07933e8e&scoped=true"
import script from "./addEvidence.vue?vue&type=script&lang=js"
export * from "./addEvidence.vue?vue&type=script&lang=js"
import style0 from "./addEvidence.vue?vue&type=style&index=0&id=07933e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07933e8e",
  null
  
)

export default component.exports